// 360度チーム進捗計算に必要なチームメンバーIDの収集ヘルパー
//
// ホーム(LandingPage)・マイサーベイ(MySurveyPage)は、360度系サーベイ
// （40010/60020）の「チーム内回答状況」（makeTeam / isLastSeasonComplete）を
// 計算するためにチームメンバーのトークン情報を必要とする。
// 旧来はグループ全ユーザー（GET /api/users/group/:groupCode）を取得していたが、
// 数千名グループでは表示遅延の主因になるため、本ヘルパーで
// 「自分が本人(hero)として属する relation_360 エントリの boss/partner/sub」だけを
// 集め、POST /api/users/team-members で絞り込み照会する方式に変更した。
// 360度系サーベイが無いユーザーはIDが0件になり、照会自体を省略できる。

/**
 * 自分のチームメンバー（boss/partner/sub）のユーザIDを重複なしで収集する
 * @param {Array<Array>} seasonArrays シーズン配列の配列
 *   （SurveySeason 一覧と Group.survey_season のように複数ソースを渡せる。
 *     前シーズン完了判定 isLastSeasonComplete が Group 側の埋め込みシーズンを
 *     参照するため、両方を渡して取りこぼしを防ぐ）
 * @param {string} myUserId ログインユーザーの _id
 * @returns {Array<string>} チームメンバーのユーザID配列
 */
export const collectMyTeamMemberIds = (seasonArrays, myUserId) => {
  const ids = new Set();
  (seasonArrays || []).forEach((seasons) => {
    (seasons || []).forEach((season) => {
      const team = (season.relation_360 || []).find(
        (item) => item.user_id === myUserId
      );
      if (!team) return;
      [
        ...(team.boss || []),
        ...(team.partner || []),
        ...(team.sub || []),
      ].forEach((id) => {
        if (id) ids.add(id);
      });
    });
  });
  return Array.from(ids);
};
